import { useRef } from "react";
import Icon from "../../Icon/Icon.jsx";
import { func, string } from "prop-types";

const propTypes = {
  returnToPreviousScreen: func,
  label: string,
};

const MobileMenuContextLabelButton = (props) => {
  const { returnToPreviousScreen, label } = props;
  const groupLabelRef = useRef();

  return (
    <div className="mobile-menu__context-button-container">
      <button
        type="button"
        onClick={returnToPreviousScreen}
        className="mobile-menu__context-button"
        ref={groupLabelRef}
        aria-label={`Back to ${label}`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="7"
          height="14"
          viewBox="0 0 7 14"
          className="mobile-menu__context-icon"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.33454 7.80693C0.264219 7.73515 0.202171 7.65493 0.158738 7.56522C0.0532575 7.38578 0.000516891 7.19791 0.000516891 7.00053C0.000516891 6.80315 0.0532575 6.61422 0.150465 6.44323C0.194933 6.35456 0.255946 6.27329 0.325233 6.19202L5.68821 0.728778C5.98707 0.423741 6.47001 0.423741 6.76887 0.728778C7.07704 1.03382 7.07704 1.52779 6.76887 1.83283L1.72281 7L6.76887 12.1682C7.07704 12.4733 7.07704 12.9662 6.76887 13.2712C6.47001 13.5763 5.98707 13.5763 5.68821 13.2712L0.33454 7.80693Z"
            fill="currentColor"
          />
        </svg>
        <span className="mobile-menu__context-label">{label}</span>
      </button>
    </div>
  );
};

MobileMenuContextLabelButton.propTypes = propTypes;
export default MobileMenuContextLabelButton;
